import { serviceRequest } from '../types';

// `append` keeps the pages already in the store, for the lists that scroll instead of paginating.
export const getServiceRequestList = ({ limit, page, query, payload, give_actions, tab, callCountApi, append }) => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_LIST_REQUEST,
        payload: { limit, page, query, payload, give_actions, tab, callCountApi, append }
    };
};

export const getServiceRequestCount = () => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_COUNT_REQUEST
    };
};

export const createServiceRequest = ({ payload, formName, onSuccess, onError, milestone_id, boq, refreshAsset }) => {
    return {
        type: serviceRequest.CREATE_SERVICE_REQUEST_REQUEST,
        payload: { payload, formName, onSuccess, onError, milestone_id, boq, refreshAsset }
    };
};

export const updateServiceRequest = ({ ticketId, payload, formName, onSuccess }) => {
    return {
        type: serviceRequest.UPDATE_SERVICE_REQUEST_REQUEST,
        payload: { ticketId, payload, formName, onSuccess }
    };
};

export const deleteServiceRequest = ({ ticketId, formName }) => {
    return {
        type: serviceRequest.DELETE_SERVICE_REQUEST_REQUEST,
        payload: { ticketId, formName }
    };
};

export const getServiceRequestFilterList = ({ filter_labels, project_ids, q, formName }) => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_FILTER_LIST_REQUEST,
        payload: { filter_labels, project_ids, q, formName }
    };
};


export const holdOrResumeServiceRequest = ({ ticketId, state, formName, payload }) => {
    return {
        type: serviceRequest.HOLD_OR_RESUME_SERVICE_REQUEST_REQUEST,
        payload: { ticketId, state, formName, payload }
    };
};

export const hardCloseServiceRequest = ({ ticketId, remark, closed_at, formName, milestone_ids }) => {
    return {
        type: serviceRequest.HARD_CLOSE_SERVICE_REQUEST_REQUEST,
        payload: { ticketId, remark, closed_at, formName, milestone_ids }
    };
};
export const bulkTicketCreate = ({ formName, type, url, project_id, org_id, site_type, warehouse_id }) => {
    return {
        type: serviceRequest.BULK_TICKET_CREATE_REQUEST,
        payload: { formName, type, url, project_id, org_id, site_type, warehouse_id }
    };
};
export const bulkTicketExampleFile = ({ type }) => {
    return {
        type: serviceRequest.BULK_TICKET_EXAMPLE_FILE_REQUEST,
        payload: { type }
    };
};

export const getEligibleAgents = ({ ticketId, limit, page, query, payload }) => {
    return {
        type: serviceRequest.GET_ELIGIBLE_AGENTS_REQUEST,
        payload: { ticketId, limit, page, query, payload }
    };
};

export const getEligibleEngineers = ({ user_id, org_id, limit, page, query, payload }) => {
    return {
        type: serviceRequest.GET_ELIGIBLE_ENGINEERS_REQUEST,
        payload: { user_id, org_id, limit, page, query, payload }
    };
};

export const acceptTicketMilestone = ({ ticketId, milestoneIds, payload, formName, source, callTicketDetails }) => {
    return {
        type: serviceRequest.ACCEPT_MILESTONE_REQUEST,
        payload: { ticketId, milestoneIds, payload, formName, source, callTicketDetails }
    };
};

export const assignAgentsToTicketMilestone = ({ ticketId, milestoneId, payload, formName, callTicketDetails }) => {
    return {
        type: serviceRequest.ASSIGN_AGENTS_REQUEST,
        payload: { ticketId, milestoneId, payload, formName, callTicketDetails }
    };
};


export const broadcastTicketMilestone = ({ ticketId, milestoneId, payload, formName }) => {
    return {
        type: serviceRequest.BROADCAST_REQUEST,
        payload: { ticketId, milestoneId, payload, formName }
    };
};

export const siteCompleteTicketMilestone = ({ ticketId, milestoneId, formName, refresh }) => {
    return {
        type: serviceRequest.SITE_COMPLETE_REQUEST,
        payload: { ticketId, milestoneId, formName, refresh }
    };
};

export const executionDateTicketMilestone = ({ ticketId, milestoneId, formName, payload, }) => {
    return {
        type: serviceRequest.EXECUTION_DATE_REQUEST,
        payload: { ticketId, milestoneId, formName, payload }
    };
};


export const reAssignAgentToServiceReuest = ({ ticketId, milestoneId, payload, formName, callTicketDetails }) => {
    return {
        type: serviceRequest.REASSIGN_AGENTS_REQUEST,
        payload: { ticketId, milestoneId, payload, formName, callTicketDetails }
    };
};

export const assignHelpdesk = ({ payload, formName, ticketId }) => {
    return {
        type: serviceRequest.ASSIGN_HELPDESK_REQUEST,
        payload: { payload, formName, ticketId }
    };
};


export const getServiceRequestById = ({ ticketId, callDetail }) => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_BY_ID_REQUEST,
        payload: { ticketId, callDetail }
    };
};

export const createOrEditServiceRequestPayment = ({ payload, formName, ticketId, milestone_id, onSuccess }) => {
    return {
        type: serviceRequest.SERVICE_REQUEST_PAYMENT_CREATE_OR_EDIT_REQUEST,
        payload: { payload, formName, ticketId, milestone_id, onSuccess }
    };
};

export const approveServiceRequestPayment = ({ payload, formName, ticketId, milestone_id }) => {
    return {
        type: serviceRequest.SERVICE_REQUEST_PAYMENT_APPROVE_REQUEST,
        payload: { payload, formName, ticketId, milestone_id }
    };
};

export const rejectServiceRequestPayment = ({ payload, formName, ticketId, milestone_id }) => {
    return {
        type: serviceRequest.SERVICE_REQUEST_PAYMENT_REJECT_REQUEST,
        payload: { payload, formName, ticketId, milestone_id }
    };
};

export const rollbackServiceRequestPayment = ({ payload, formName, ticketId, milestone_id }) => {
    return {
        type: serviceRequest.SERVICE_REQUEST_PAYMENT_ROLLBACK_REQUEST,
        payload: { payload, formName, ticketId, milestone_id }
    };
};

export const getServiceRequestPayments = ({ ticketId, payload, roles, org_id }) => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_PAYMENTS_REQUEST,
        payload: { ticketId, payload, roles, org_id }
    };
};

export const getServiceRequestMilestones = ({ id }) => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_MILESTONES_REQUEST,
        payload: { id }
    };
};

export const reachedSiteServiceRequest = ({ ticketId, milestoneId, formName, refresh }) => {
    return {
        type: serviceRequest.REACHED_SITE_SERVICE_REQUEST_REQUEST,
        payload: { ticketId, milestoneId, formName, refresh }
    };
};


export const approveTicketMilestone = ({ ticketId, milestoneId, payload, formName, onSuccess }) => {
    return {
        type: serviceRequest.APPROVE_TICKET_MILESTONE_REQUEST,
        payload: { ticketId, milestoneId, payload, formName, onSuccess }
    };
};

export const rejectTicketMilestone = ({ ticketId, milestoneId, payload, formName }) => {
    return {
        type: serviceRequest.REJECT_TICKET_MILESTONE_REQUEST,
        payload: { ticketId, milestoneId, payload, formName }
    };
};


export const raiseSignoffTicketMilestone = ({ ticketId, milestoneId, payload, formName, closeModal, onSuccess }) => {
    const actionPayload = { ticketId, milestoneId, payload, formName };
    if (closeModal !== undefined) actionPayload.closeModal = closeModal;
    if (typeof onSuccess === 'function') actionPayload.onSuccess = onSuccess;
    return {
        type: serviceRequest.TICKET_RAISE_SIGNOFF_REQUEST,
        payload: actionPayload
    };
};


export const updateServiceRequestTask = ({ ticketId, taskId, payload, formName }) => {
    return {
        type: serviceRequest.SERVICE_REQUEST_TASK_UPDATE_REQUEST,
        payload: { ticketId, taskId, payload, formName }
    };
};


export const getAllTicketPayment = ({ limit, page, query, payload }) => {
    return {
        type: serviceRequest.GET_ALL_TICKET_PAYMENTS_REQUEST,
        payload: { limit, page, query, payload }
    }
};

export const updateRma = ({ payload, formName, source }) => {
    return {
        type: serviceRequest.UPDATE_RMA_REQUEST,
        payload: { payload, formName, source }
    };
};



export const mapFaultyAsset = ({ payload, formName }) => {
    return {
        type: serviceRequest.MAP_FAULTY_ASSET_REQUEST,
        payload: { payload, formName }
    };
};

export const triggeredServiceRequest = ({ payload, limit, page, query, user_id }) => {
    return {
        type: serviceRequest.TRIGGERED_SERVICE_REQUEST_REQUEST,
        payload: { payload, limit, page, query, user_id }
    };
};



export const updateRemark = ({ ticketId, ledgerId, payload, formName }) => {
    return {
        type: serviceRequest.UPDATE_REMARK_REQUEST,
        payload: { ticketId, ledgerId, payload, formName }
    };
};


export const addAttributes = ({ ticketId, key, payload, formName }) => {
    return {
        type: serviceRequest.ADD_ATTRIBUTES_REQUEST,
        payload: { ticketId, key, payload, formName }
    };
};



export const getExtraDetailsByIds = ({ ids }) => {
    return {
        type: serviceRequest.GET_EXTRA_DETAILS_BY_IDS_REQUEST,
        payload: { ids }
    };
};

export const cloneServiceRequest = ({ id, formName }) => {
    return {
        type: serviceRequest.CLONE_SERVICE_REQUEST_REQUEST,
        payload: { id, formName }
    };
};


export const uploadTaskAndUpdate = ({ formName, payload }) => {
    return {
        type: serviceRequest.UPLOAD_TASKS_AND_UPDATE,
        payload: { formName, payload }
    };
};

export const releaseVendor = ({ formName, ticketId, milestoneId, closeModal, onSuccess, refresh }) => {
    return {
        type: serviceRequest.RELEASE_SERVICE_REQUEST,
        payload: { formName, ticketId, milestoneId, closeModal, onSuccess, refresh }
    };
}

export const addBoqInServiceRequest = ({ formName, payload, onSuccess, onError, closeModal, refresh, showToast, pavFlow }) => {
    const actionPayload = { formName, payload, onSuccess, closeModal };
    if (pavFlow === true) {
        actionPayload.pavFlow = true;
        actionPayload.onError = onError;
        actionPayload.refresh = refresh;
        actionPayload.showToast = showToast;
    }
    return {
        type: serviceRequest.ADD_BOQ_IN_SERVICE_REQUEST,
        payload: actionPayload
    };
}

export const goingToSiteServiceRequest = ({ ticketId, milestoneId, formName, refresh }) => {
    return {
        type: serviceRequest.GOING_TO_SITE_SERVICE_REQUEST_REQUEST,
        payload: { ticketId, milestoneId, formName, refresh }
    };
};



export const addDocketDetails = ({ ticketId, milestoneId, payload, formName }) => {
    return {
        type: serviceRequest.ADD_DOCKET_DETAILS_REQUEST,
        payload: { ticketId, milestoneId, payload, formName }
    };
};

export const getServiceRequestHistory = ({ ticketId }) => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_HISTORY_REQUEST,
        payload: { ticketId }
    };
};

export const addMilestoneInServiceRequest = ({ ticketId, payload, formName }) => {
    return {
        type: serviceRequest.ADD_MILESTONE_IN_SERVICE_REQUEST,
        payload: { ticketId, payload, formName }
    };
};


export const bulkServiceRequestStateChange = ({ payload, formName, state }) => {
    return {
        type: serviceRequest.BULK_SERVICE_REQUEST_STATE_CHANGE_REQUEST,
        payload: { payload, formName, state }
    };
};



export const bulkCloneServiceRequest = ({ payload, formName }) => {
    return {
        type: serviceRequest.BULK_CLONE_SERVICE_REQUEST_REQUEST,
        payload: { payload, formName }
    };
};

export const bulkDeleteServiceRequest = ({ payload, formName }) => {
    return {
        type: serviceRequest.BULK_DELETE_SERVICE_REQUEST_REQUEST,
        payload: { payload, formName }
    };
};

export const bulkEditExecutionDateOfServiceRequest = ({ payload, formName }) => {
    return {
        type: serviceRequest.BULK_EDIT_EXECUTION_DATE_OF_SERVICE_REQUEST_REQUEST,
        payload: { payload, formName }
    };
};

export const bulkAssignAgentsOfServiceRequest = ({ payload, formName }) => {
    return {
        type: serviceRequest.BULK_ASSIGN_AGENTS_OF_SERVICE_REQUEST_REQUEST,
        payload: { payload, formName }
    };
};


export const addServiceRequestRemark = ({ ticketId, payload, formName, closeModal, callHistory }) => {
    return {
        type: serviceRequest.ADD_SERVICE_REQUEST_REMARK_REQUEST,
        payload: { ticketId, payload, formName, closeModal, callHistory }
    };
};

export const bulkSignoffUnlockAction = ({ formName, milestone_ids, remark }) => {
    return {
        type: serviceRequest.BULK_SIGN_OFF_UNLOCK_REQUEST,
        payload: { formName, milestone_ids, remark }
    };
};

export const unlockSignoffServiceRequest = ({ ticketId, milestoneId, formName, remark }) => {
    return {
        type: serviceRequest.UNLOCK_SIGN_OFF_SERVICE_REQUEST,
        payload: { ticketId, milestoneId, formName, remark }
    };
};


export const removeBulkAgent = ({ ticket_ids, roles, formName }) => ({
    type: serviceRequest.REMOVE_BULK_AGENTS_REQUEST,

    payload: { ticket_ids, roles, formName }
})


export const generateSignoffReport = ({ ticketId, formName }) => {
    return {
        type: serviceRequest.GENERATE_SIGN_OFF_REPORT_REQUEST,
        payload: { ticketId, formName }
    };
};


export const generateTicketReport = ({ ticketId, formName }) => {
    return {
        type: serviceRequest.GENERATE_TICKET_REPORT_REQUEST,
        payload: { ticketId, formName }
    };
};


export const updateNoResponse = ({ ticketId, milestoneId, event, formName }) => {
    return {
        type: serviceRequest.UPDATE_NO_RESPONSE_REQUEST,
        payload: { ticketId, milestoneId, event, formName }
    };
};

export const getSupportTrackTicketDetails = ({ ticketId }) => {
    return {
        type: serviceRequest.SUPPORT_TRACK_TICKET_DETAILS_REQUEST,
        payload: { ticketId }
    };
};

export const getServiceRequestCountV2 = (payload) => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_COUNT_V2,
        payload: payload
    }
}

export const bulkBroadcast = ({ payload, formName }) => {
    return {
        type: serviceRequest.BULK_BROADCAST_REQUEST,
        payload: { payload, formName }
    }
}


export const downloadCustomerSignoffReport = ({ payload, formName }) => {
    return {
        type: serviceRequest.DOWNLOAD_CUSTOMER_SIGNOFF_REPORT_REQUEST,
        payload: { payload, formName }
    }
}

// `files` are uploaded to S3 first and sent as the `attachments` array of the approval payload.
export const customerApprovalRecievedRequest = ({ payload, files, formName, onSuccess }) => {
    return {
        type: serviceRequest.CUSTOMER_APPROVAL_RECEIVED_REQUEST,
        payload: { payload, files, formName, onSuccess }
    }
}

export const revokeCustomerApprovalRequest = ({ payload, formName, onSuccess }) => {
    return {
        type: serviceRequest.REVOKE_CUSTOMER_APPROVAL_REQUEST,
        payload: { payload, formName, onSuccess }
    }
}

export const getBillingRemarks = ({ limit, page, query, payload }) => {
    return {
        type: serviceRequest.GET_BILLING_REMARKS_REQUEST,
        payload: { limit, page, query, payload }
    }
}
export const editCustomerRequest = ({ id, media_ids, formName }) => {
    return {
        type: serviceRequest.EDIT_CUSTOMER_REPORT_REQUEST,
        payload: { id, media_ids, formName }
    }
}

export const holdServiceRequestPayment = ({ payload, formName, ticketId, milestone_id }) => {
    return {
        type: serviceRequest.SERVICE_REQUEST_PAYMENT_HOLD_REQUEST,
        payload: { payload, formName, ticketId, milestone_id }
    };
}


export const removeAssetFromTicket = ({ id, asset_id, formName, onSuccess }) => {
    return {
        type: serviceRequest.REMOVE_ASSET_FROM_TICKET_REQUEST,
        payload: { id, asset_id, formName, onSuccess }
    };
}



export const fixRma = ({ id, milestoneId, formName, payload }) => {
    return {
        type: serviceRequest.FIX_RMA_REQUEST,
        payload: { id, milestoneId, formName, payload }
    };
}

// Approve or reject one PAV asset after its milestone attachments were reviewed.
export const verifyPavAssetPhysically = ({ ticketId, milestoneId, assetId, isVerified, remark, formName, onSuccess, onError, refresh = true }) => {
    return {
        type: serviceRequest.PAV_ASSET_PHYSICAL_VERIFICATION_REQUEST,
        payload: { ticketId, milestoneId, assetId, isVerified, remark, formName, onSuccess, onError, refresh }
    };
}

export const getServiceRequestCountByStatus = (payload) => {
    return {
        type: serviceRequest.GET_SERVICE_REQUEST_COUNT_BY_STATUS_REQUEST,
        payload: payload
    }
}

export const updateServiceRequestCustomerSignoffStatus = ({ ticketId, milestoneId, payload, formName }) => {
    return {
        type: serviceRequest.UPDATE_CUSTOMER_SIGNOFF_STATUS_REQUEST,
        payload: { ticketId, milestoneId, payload, formName }
    };
}

export const getVisitHistory = ({ ticketId }) => {
    return {
        type: serviceRequest.GET_VISIT_HISTORY_REQUEST,
        payload: { ticketId }
    }
}
